import { Alert, AlertDescription } from '@treasuryspring/spring-ui';
import { useMemo } from 'react';

import { Banner } from '@/components';
import { useAppStore } from '@/stores/useAppStore';
import { HttpError } from '@/utils/api';

import icon from '../assets/ts-favicon.svg';

interface ErrorPageProps {
  error: Error | null;
}

export default function ErrorPage({ error }: ErrorPageProps) {
  const { token } = useAppStore();
  const message = useMemo(() => {
    if (!token) {
      return 'You are not authorized to view this page. Please ensure you have provided a valid access token in the URL.';
    }
    if (error instanceof HttpError && error.status === 401) {
      return 'Your access token has expired (or is no longer valid). Please request a new link.';
    }
    return error?.message;
  }, [error, token]);

  return (
    <>
      <Banner />
      <div className="gap-m absolute top-1/2 left-1/2 flex -translate-1/2 flex-col items-center">
        <img src={icon} alt="TreasurySpring" className="mb-m w-[4rem]" />
        <h1 className="text-h5">Something went wrong</h1>
        <Alert variant="warning" className="w-[30rem] max-w-10/12">
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      </div>
    </>
  );
}
